import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';
import { Icon } from 'components/Icon/Icon';

import { SortingDirection } from 'types';

import { ReactComponent as ArrowUp } from 'assets/icons/main-16/arrow-sort-up--16.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/main-16/arrow-sort-down--16.svg';

export interface SortingField<T> {
    name: T;
    label: string;
}

export interface SortingProps<T> {
    fields: SortingField<T>[];
    sorting: {
        field: T;
        direction: SortingDirection;
    };
    onToggle: (key: T) => void;
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
    },
    item: {
        cursor: 'pointer',
        marginRight: theme.spacing(3),
        '&:last-child': {
            marginRight: 0,
        },
    },
    text: {
        lineHeight: '16px',
        verticalAlign: 'middle',
    },
    icon: {
        verticalAlign: 'middle',
    },
    fakeIcon: {
        display: 'inline-block',
        width: theme.spacing(2),
    },
}));

const getArrowComponent = (sortingDirection: SortingDirection) => {
    return sortingDirection === SortingDirection.ASC ? ArrowUp : ArrowDown;
};

export const Sorting = <T extends string>(props: SortingProps<T>) => {
    const { fields, sorting, onToggle } = props;
    const classes = useStyles();
    return (
        <div className={classes.container}>
            {fields.map(field => (
                <div key={field.name} className={classes.item} onClick={() => onToggle(field.name)}>
                    <Text className={classes.text} typography={TextTypography.BODY_ACCENT}>
                        {field.label}
                    </Text>
                    {sorting.field === field.name ? (
                        <Icon
                            className={classes.icon}
                            component={getArrowComponent(sorting.direction)}
                            svgSize={16}
                            size={16}
                        />
                    ) : (
                        <span className={classes.fakeIcon} />
                    )}
                </div>
            ))}
        </div>
    );
};
